import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {PoweredByClickEvent} from "../models/events/powered-by.click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";

export class PoweredByClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.poweredByClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PoweredByClickEvent;
  }
}
